import { withFieldGroup } from '@massilia/features'
import { Label, RadioGroup, RadioGroupItem } from '@massilia/ui'

import type { CheckoutFormValues } from '../checkout-form.schema'

export const FloaSubForm = withFieldGroup({
  defaultValues: {} as Pick<
    CheckoutFormValues,
    'billingCity' | 'billingCountryCode' | 'billingStreet' | 'billingZipCode' | 'floaPayType'
  >,
  render: function FloaSubFormFields({ group }) {
    return (
      <div className="flex flex-col gap-4">
        <p className="text-gray-light-700 text-sm">
          Vous serez redirigé vers la plateforme sécurisée FLOA Bank pour finaliser votre paiement.
        </p>

        {/* 3x / 4x selector */}
        <group.AppField name="floaPayType">
          {(field) => (
            <RadioGroup
              onValueChange={(value) => field.handleChange(value as '3XG' | '4XG')}
              value={field.state.value as '3XG' | '4XG'}
            >
              <div className="flex items-center gap-2">
                <RadioGroupItem value="3XG" />
                <Label className="cursor-pointer font-normal" htmlFor="3XG">
                  3 fois
                </Label>
                <RadioGroupItem value="4XG" />
                <Label className="font-normal text-gray-600" htmlFor="4XG">
                  4 fois
                </Label>
              </div>
            </RadioGroup>
          )}
        </group.AppField>

        {/* Billing address */}
        <div className="flex flex-col gap-3">
          <Label className="text-sm font-medium">Adresse de facturation</Label>

          <group.AppField name="billingStreet">
            {(field) => <field.TextField placeholder="Rue" />}
          </group.AppField>

          <div className="flex gap-3">
            <group.AppField name="billingZipCode">
              {(field) => <field.TextField placeholder="Code postal" />}
            </group.AppField>

            <group.AppField name="billingCity">
              {(field) => <field.TextField placeholder="Ville" />}
            </group.AppField>
          </div>

          <group.AppField name="billingCountryCode">
            {(field) => <field.CountryAutocompleteField placeholder="Pays" />}
          </group.AppField>
        </div>
      </div>
    )
  },
})
